import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { TextBgColorWithCadre } from 'app/shared/components/common/text-style/text-bg-color-with_cadre';
import { findStatusCmsInfo } from 'app/shared/util/methode-util';
import React, { useEffect, useState } from 'react';

import './style.scss';

export interface IContractDetails {
  subscription: any;
  startDate: any;
  phoneNumber: any;
  imei: any;
  changeMineSubscription?: any;
  accoutAssignementCms?: any;
  contractCustomerCms?: any
  status?: number;
  brand: string;
  model: string;
}
const DesktopContractDetails = ({
  subscription,
  startDate,
  changeMineSubscription,
  accoutAssignementCms,
  contractCustomerCms,
  status,
  brand,
  model
}: IContractDetails) => {
  const [assignable, setAssignable] = useState(1);
  const findStatusCmsInfoValue = findStatusCmsInfo(contractCustomerCms?.contract_status_items, status);
  const handleChange = event => {
    setAssignable(parseInt(event.target.value, 10));
    changeMineSubscription && changeMineSubscription(subscription, event.target.value === 1);
  };
  useEffect(() => {
    changeMineSubscription && changeMineSubscription(subscription, true);
  }, []);

  return (
    <>
      <div className="all-insured-desktop h-100">
        <div className="insured-desktop">
          <div className="tel-icon col-2">
            <img src={accoutAssignementCms?.search_contract?.smartphone_icone} />
          </div>

          <div className="details-sub col-6 pr-2">
            <h5>
              {accoutAssignementCms?.search_contract?.subscription_label} {subscription}
            </h5>

            <p className="font-normal">
              {accoutAssignementCms?.search_contract?.date_label} {startDate}
            </p>
            <p className="font-normal">
              {brand} {model}
            </p>
            {status !== undefined && status !== null &&
              <div className="sub-status w-50 py-2">
                <TextBgColorWithCadre
                  text={findStatusCmsInfoValue?.label}
                  backgroundColor={findStatusCmsInfoValue?.stylecolor}
                  textColor={findStatusCmsInfoValue?.text_color}
                  icon={findStatusCmsInfoValue?.icon?.url}
                />
              </div>
            }
          </div>

          <div className="btns col-4">
            {changeMineSubscription && (
              <FormControl fullWidth>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={assignable}
                  onChange={handleChange}
                >
                  <FormControlLabel value={1} control={<Radio />} label={accoutAssignementCms?.assaignement_contract?.correct_informations_select} />
                  <FormControlLabel value={0} control={<Radio />} label={accoutAssignementCms?.assaignement_contract?.wrong_informations_select} />
                </RadioGroup>
              </FormControl>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopContractDetails;
